import client from "api/client";
import BaseApiResponseModel from "api/model/BaseApiResponseModel";
import ApiPath from "../ApiPath";
import FilterRequestModel from "./model/FilterRequestModel";
import { UploadResponseModel } from "./model/UploadResponseModel";
import axios from "axios";
import qs from "qs";
import api from "api/client";

interface SimFlowParams {
  file: File;
  action: "HANDOVER" | "RECALL";
  receiver_agency_id: string;
  deposit_amount?: number;
  note?: string;
}
//simPublic
const getSimPublic = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.GETSIMPUBLIC, props);
};

const simImportPublic = async (
  file: File,
  store_type: string,
): Promise<BaseApiResponseModel<UploadResponseModel>> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("store_type", store_type);
  const path = ApiPath.IMPORTSIMPUBLIC;

  return await client.post(path, formData, {
    transformRequest: [(data: File) => data],
  });
};

//nicesim
const getNiceSim = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.GETNICESIM, props);
};

//simKitPick
const getSimKitPick = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.GETSIMKITPICK, props);
};

const simKitPickInit = async (
  props: any,
): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.SIMKITPICKINIT, props);
};

const simKitPickPackage = async (
  id: string,
  props: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SIMKITPICKPAC.replace("{id}", id);
  return await client.post(url, props);
};

const simKitPickRegister = async (
  id: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SIMKITPICKREGISTER.replace("{id}", id);
  return await client.post(url);
};

const simKitPickPay = async (
  id: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SIMKITPICKPAY.replace("{id}", id);
  return await client.post(url);
};

//Nego & Deposit
const simNego = async (
  props: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.SIMKITPICKNEGO, props);
};

const simNegoRequest = async (
  values: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.SIMKITPICKNEGO, values);
};

const simDeposit = async (
  id: string,
  values?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SIMDEPOSIT.replace("{id}", id);
  return await client.post(url, values);
};

const simHistoryNeo = async (
  id: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.HISNEO.replace("{id}", id);
  return await client.get(url);
};

const simPay = async (
  id: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SIMKITPICKREGISTER.replace("{id}", id);
  return await client.post(url);
};

const updateSimDeposit = async (
  id: string,
  values?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATESIMDEPOSIT.replace("{id}", id);
  return await client.put(url, values);
};

const simKitPickTransfer = async (
  id: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SIMKITPICKTRANSFER.replace("{id}", id);
  return await client.post(url);
};

const simKitPickDetail = async (
  id: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SIMKITPICKDETAIL.replace("{id}", id);
  return await client.get(url);
};

//shopping-cart
const getSimPickCart = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.SIMKITPICKCART, props);
};

//sim
const getSim = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.GETSIM, props);
};

const simImport = async (
  file: File,
): Promise<BaseApiResponseModel<UploadResponseModel>> => {
  const formData = new FormData();
  formData.append("file", file);

  const path = ApiPath.SIMIMPORT;

  return await client.post(path, formData, {
    transformRequest: [(data: File) => data],
  });
};

const simFlow = async (
  params: any,
): Promise<BaseApiResponseModel<UploadResponseModel>> => {
  const { file, action, agency_id } = params;

  const formData = new FormData();

  formData.append("file", file);
  formData.append("action", action);
  formData.append("agency_id", agency_id);
  formData.append("receiver_agency_id", agency_id);

  const path = ApiPath.SIMFLOW;

  return await client.post(path, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const requestOtp = async (props: any) => {
  const params = new URLSearchParams(props).toString();
  return client.post(ApiPath.OTP, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const simAgentFlow = async (
  params: any,
): Promise<BaseApiResponseModel<UploadResponseModel>> => {
  const { file, action, agency_id } = params;

  const formData = new FormData();

  formData.append("file", file);
  formData.append("action", action);
  formData.append("agency_id", agency_id);
  formData.append("receiver_agency_id", agency_id);

  const path = ApiPath.SIMFAGENTLOW;

  return await client.post(path, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const confirmOtp = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CONFIRMOTP, props);
};

const simTransfer = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.SIMTRANFER, props);
};

const simTem = async (props: any): Promise<Blob> => {
  const queryParams = new URLSearchParams(props).toString();

  const url = `${ApiPath.SIMTEMPLATE}?${queryParams}`;

  const response = await axios.get(url, {
    responseType: "blob",
  });
  return response.data;
};

const simTemHand = async (props: any): Promise<Blob> => {
  const queryParams = new URLSearchParams(props).toString();

  const url = `${ApiPath.SIMHAND}?${queryParams}`;

  const response = await axios.get(url, {
    responseType: "blob",
  });

  return response.data;
};

const simTemRef = async (props: any): Promise<Blob> => {
  const queryParams = new URLSearchParams(props).toString();

  const url = `${ApiPath.SIMREFUND}?${queryParams}`;

  const response = await axios.get(url, {
    responseType: "blob",
  });
  return response.data;
};

const simReport = async (props: any): Promise<Blob> => {
  return await client.getDownload(ApiPath.SIMEXPORT, props);
};

//simEmbryo
const simEmbryo = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.GETSIMEMBRYO, props);
};

const simBaseImport = async (
  props?: any,
): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.SIMBASEIMPORT, props);
};

const simBaseFlow = async (props?: any): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.SIMBASEFLOW, props);
};

const simBaseOTP = async (props?: any): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.SIMBASEOTP, props);
};

const simBaseReport = async (props: any): Promise<Blob> => {
  return await client.getDownload(ApiPath.SIMBASEEXPORT, props);
};

//package
const getPackage = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETPAC, props);
};

const createPackage = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATEPAC, props);
};

const updatePackage = async (
  id: any,
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATEPAC.replace("{id}", id);
  return await client.put(url, props);
};

//client
const getClient = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETCLIENT, props);
};

//dkttb
const getDkttb = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.SKRESGISTER, props);
};

const getDkttbDetail = async (
  id?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SKRESGISTERDETAIL.replace("{id}", id);
  return await client.get(url);
};

const getSimkit = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETDKTTB, props);
};

const simkitBulk = async (
  file: File,
): Promise<BaseApiResponseModel<UploadResponseModel>> => {
  const formData = new FormData();
  formData.append("file", file);

  const path = ApiPath.BULK;

  return await client.post(path, formData, {
    transformRequest: [(data: File) => data],
  });
};

const getSimkitAvailable = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.SKAVAILABLE, props);
};

const getPlansAvailable = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.PLANSAVAILABLE, props);
};

const getSimkitInit = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.SKINIT, props);
};

const getSimkitInitDetail = async (
  id?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.SKINITDETAIL.replace("{id}", id ?? "");
  return await client.get(url);
};

const getSimkitOCR = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.SKOCR, props);
};

const getSimkitConfirm = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.SKCOMFIRM, props);
};

const exportDkttb = async (props?: any): Promise<Blob> => {
  return await client.getDownload(ApiPath.EXPORTDKTTB, props);
};

const DkttbTEM = async (props: any): Promise<Blob> => {
  const queryParams = new URLSearchParams(props).toString();
  const url = `${ApiPath.DKTTTBTEMPLATE}?${queryParams}`;
  return await client.getDownload(url);
};

//gán gói
const getPlanAssignment = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.PLANASS, props);
};

const planAssignmentBulk = async (
  file: File,
): Promise<BaseApiResponseModel<UploadResponseModel>> => {
  const formData = new FormData();
  formData.append("file", file);

  const path = ApiPath.PLANASSBULK;

  return await client.post(path, formData, {
    transformRequest: [(data: File) => data],
  });
};

const planAddTem = async (props: any): Promise<Blob> => {
  const queryParams = new URLSearchParams(props).toString();
  const url = `${ApiPath.PLANASSTEMPLATE}?${queryParams}`;

  const response = await axios.get(url, {
    responseType: "blob",
  });

  return response.data;
};

const planAddReport = async (props: any): Promise<Blob> => {
  return await client.getDownload(ApiPath.PLANREPORT, props);
};

//tài khoản
const getUser = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETUSER, props);
};

const createUser = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATEUSER, props);
};

const getUserDetail = async (
  id?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.USERDETAIL.replace("{id}", id ?? "");
  return await client.get(url);
};

const updateUser = async (
  info: any,
  id?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.USERDETAIL.replace("{id}", id ?? "");
  return await client.put(url, info);
};

const resetPass = async (
  info?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.RESETPASS, info);
};

//getUser
const getUserSytem = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.USERSYSTEM, props);
};

//getAdminMer
const getAdminMer = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.ADMINMER, props);
};

const getAdminMerDetail = async (
  id?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATEMER.replace("{id}", id ?? "");
  return await client.get(url);
};

const createAdminMer = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATEADMER, props);
};

const createRefund = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.REFUND, props);
};

const updateAdminMer = async (
  info: any,
  id?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.DETAILADMER.replace("{id}", id ?? "");
  return await client.put(url, info);
};

//discount
const getDiscount = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETDISCOUNT, props);
};

const updateUserDiscount = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.UPDATEDISCOUNT, props);
};

const updateMutiUserDiscount = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.USERDISCOUNT, props);
};

const createDkttbDiscount = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.DKTTBDISCOUNT, props);
};

//getwallet
const getWallet = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.WALLET, props);
};

//getMer
const getMer = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.MERSUMMARY, props);
};

const getMerV2 = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.MER, props);
};

const getMerDetail = async (
  id?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATEMER.replace("{id}", id ?? "");
  return await client.get(url);
};

const createMer = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATEMER, props);
};

const updateMer = async (
  info: any,
  id?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATEMER.replace("{id}", id ?? "");
  return await client.put(url, info);
};

const handleConfirmCanelMer = async (
  id: string,
  value: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATESTATUSMER.replace("{id}", id ?? "");
  return await client.post(url, value);
};

//getTrans
const getTrans = async (
  props: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const params = new URLSearchParams();

  Object.keys(props).forEach((key) => {
    const value = props[key];

    if (Array.isArray(value)) {
      value.forEach((item) => {
        params.append(key, item.toString());
      });
    } else {
      params.append(key, value.toString());
    }
  });

  const url = `${ApiPath.TRANS}?${params.toString()}`;

  return await client.get(url);
};

const transReport = async (props: any): Promise<Blob> => {
  const params = new URLSearchParams();

  Object.keys(props).forEach((key) => {
    const value = props[key];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        params.append(key, item.toString());
      });
    } else {
      params.append(key, value.toString());
    }
  });

  const url = `${ApiPath.TRANSREPORT}?${params.toString()}`;
  return await client.getDownload(url);
};

//limit
const getLimit = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.LIMIT, props);
};

const getLimitDetail = async (
  id: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.LIMITDETAIL.replace("{id}", id ?? "");
  return await client.get(url);
};

const createLimit = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATELIMIT, props);
};

const confirmLimit = async (
  id: string,
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.CONFIRMLIMIT.replace("{id}", id ?? "");
  return await client.post(url, props);
};

const updateLimit = async (
  id: string,
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATELIMIT.replace("{id}", id ?? "");
  return await client.put(url, props);
};

const limitReport = async (props: any): Promise<Blob> => {
  return await client.getDownload(ApiPath.LIMITREPORT, props);
};

//rose
const getRose = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.ROSE, props);
};

const roseInit = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const formData = new FormData();
  formData.append("agency_id", props.store_id);
  formData.append("pttb_commission", props.pttb_commission);
  formData.append("plan_commission", props.plan_commission);
  formData.append("maintain_commission", props.maintain_commission);
  formData.append("upload_file", props.file);

  return await client.post(ApiPath.ROSEINIT, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

//store
const getStore = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.MERSUMMARY, props);
};

//agency
const getAgency = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.AGENCY, props);
};

const deteleDiscountAgency = async (
  userId?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.delete(
    ApiPath.DELETEDISCOUNT,
    { userId },
    { useBody: true },
  );
};

//profile
const getAmount = async (
  id?: string,
  walletID?: string,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.WALLETS.replace("{id}", id ?? "").replace(
    "{walletID}",
    walletID ?? "",
  );
  return await client.get(url);
};

const getProfile = async (): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.PROFILE);
};

const getNotiUser = async (props?: any): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.USERNOTI, props);
};

const getSetting = async (props?: any): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.SETTING, props);
};

//topup
const getTopup = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETTOPUP, props);
};

const createTopup = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATETOPUP, props);
};

const updateTopup = async (
  id: any,
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATETOPUP.replace("{id}", id);
  return await client.put(url, props);
};

const topupInit = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.TOPUPINIT, props);
};

const topupConfirm = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.TOPUPCONFIRM, props);
};

//card
const getCard = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETCARD, props);
};

const createCard = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATECARD, props);
};

const updateCard = async (
  id: any,
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATECARD.replace("{id}", id);
  return await client.put(url, props);
};

const cardInit = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CARDINIT, props);
};

const cardConfirm = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CARDCONFIRM, props);
};

//data
const getData = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETDATA, props);
};

const getDataUnit = async (
  props?: FilterRequestModel,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.get(ApiPath.GETDATAUNIT, props);
};

const createData = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.CREATEDATA, props);
};

const updateData = async (
  id: any,
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.UPDATEDATA.replace("{id}", id);
  return await client.put(url, props);
};

const dataInit = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.DATAINIT, props);
};

const dataDetail = async (id: string): Promise<BaseApiResponseModel<any>> => {
  const url = ApiPath.DATADETAIL.replace("{id}", id);
  return await client.get(url);
};

const dataConfirm = async (
  props?: any,
): Promise<BaseApiResponseModel<Array<any>>> => {
  return await client.post(ApiPath.DATACONFIRM, props);
};

// Check log
const checkLog = async (id: any): Promise<BaseApiResponseModel<Array<any>>> => {
  const url = ApiPath.LOGS.replace("{id}", id);
  return await client.get(url);
};

//trans
const transactionDetail = async (
  id: any,
): Promise<BaseApiResponseModel<any>> => {
  const url = ApiPath.TRANSDETAIL.replace("{id}", id);
  return await client.get(url);
};

//location
const provinces = async (): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.PROVINCES);
};

const districts = async (id: string): Promise<BaseApiResponseModel<any>> => {
  const url = ApiPath.DISTRICTS.replace("{id}", id);
  return await client.get(url);
};

const wards = async (id: string): Promise<BaseApiResponseModel<any>> => {
  const url = ApiPath.WARDS.replace("{id}", id);
  return await client.get(url);
};

const commissionDownload = async (id: any): Promise<Blob> => {
  const url = ApiPath.ROSEDOWN.replace("{id}", id);
  return await client.getDownload(url);
};

const statusMaintenanceOrder = async (): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.SETTING_STATUS_MAINTENANCE_ORDER);
};

const getMaintenanceFeatures = async (props?: FilterRequestModel,): Promise<BaseApiResponseModel<any>> => {
  return await client.get(ApiPath.SETTING_GET_MAINTENANCE_FEATURES, props);
};

const updateMaintenanceFeature = (id: string, isMaintenance: boolean) => {
  return client.put(ApiPath.SETTING_UPDATE_MAINTENANCE_FEATURE(id), { isMaintenance, });
};

export default {
  createRefund,
  provinces,
  districts,
  wards,
  updateUserDiscount,
  getDiscount,
  resetPass,
  getMerV2,
  getAdminMer,
  updateAdminMer,
  createAdminMer,
  getAdminMerDetail,
  getUserSytem,
  getNotiUser,
  getProfile,
  transactionDetail,
  getDataUnit,
  dataConfirm,
  dataInit,
  cardConfirm,
  cardInit,
  topupConfirm,
  topupInit,
  checkLog,
  updateData,
  createData,
  updateCard,
  createCard,
  updateTopup,
  createTopup,
  getCard,
  getData,
  getTopup,
  getSim,
  getPackage,
  getClient,
  simImport,
  simFlow,
  requestOtp,
  confirmOtp,
  createPackage,
  updatePackage,
  simEmbryo,
  simBaseImport,
  simBaseFlow,
  simBaseOTP,
  getAgency,
  getDkttb,
  simkitBulk,
  getSimkitAvailable,
  getSimkitInit,
  getSimkitOCR,
  getSimkit,
  getDkttbDetail,
  getPlansAvailable,
  exportDkttb,
  DkttbTEM,
  simTem,
  getPlanAssignment,
  simImportPublic,
  planAssignmentBulk,
  getUser,
  createUser,
  getUserDetail,
  updateUser,
  getMer,
  getMerDetail,
  planAddTem,
  getSimkitConfirm,
  updateMer,
  getTrans,
  getLimit,
  createLimit,
  confirmLimit,
  updateLimit,
  getRose,
  roseInit,
  getStore,
  simTemRef,
  simTemHand,
  createMer,
  getSimkitInitDetail,
  getAmount,
  planAddReport,
  limitReport,
  simReport,
  simBaseReport,
  transReport,
  dataDetail,
  handleConfirmCanelMer,
  getSimPublic,
  getSimKitPick,
  simKitPickInit,
  simKitPickPackage,
  getSimPickCart,
  simKitPickRegister,
  simKitPickDetail,
  simKitPickTransfer,
  getLimitDetail,
  getWallet,
  updateMutiUserDiscount,
  deteleDiscountAgency,
  simNegoRequest,
  createDkttbDiscount,
  getNiceSim,
  simDeposit,
  simNego,
  updateSimDeposit,
  simPay,
  simKitPickPay,
  simHistoryNeo,
  commissionDownload,
  simTransfer,
  simAgentFlow,
  getSetting,
  statusMaintenanceOrder,
  getMaintenanceFeatures,
  updateMaintenanceFeature,
};
